import React from "react";

const NotFound = () => {
  return (
    <div className="flex flex-col h-screen justify-center items-center">
      <h1 className="text-6xl font-semibold">401 Not Found</h1>
    </div>
  );
};

export default NotFound;
